import { I as t } from "../../iconLoader.gen-DPl2sVbR.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
